import { useApolloClient } from '@vue/apollo-composable'
import { ref } from 'vue'

import IS_STOCK_PHOTO_LICENSED from './isStockPhotoLicensed.gql'

export interface StockPhotoLicenseInput {
  provider: string
  stockPhotoId: string
}

export interface IsStockPhotoLicensedResponse {
  isStockPhotoLicensed: {
    url: string
    license: string
    isLicensed: boolean
  }
}

export function useIsStockPhotoLicensed() {
  const { client } = useApolloClient()
  const loading = ref(false)
  const error = ref<Error | null>(null)

  const checkLicense = async (input: StockPhotoLicenseInput) => {
    loading.value = true
    error.value = null

    try {
      const { data } = await client.query<IsStockPhotoLicensedResponse>({
        query: IS_STOCK_PHOTO_LICENSED,
        variables: { input },
      })
      return data.isStockPhotoLicensed
    } catch (e) {
      error.value = e as Error
      throw e
    } finally {
      loading.value = false
    }
  }

  return {
    checkLicense,
    loading,
    error,
  }
}
